import type {
  LeaseMediaFiles,
  LeaseMediaState,
} from "@/features/leaseMedia/types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const initialState: LeaseMediaState = {
  leaseMediaFiles: {},
};

const leaseMediaSlice = createSlice({
  name: "leaseMedia",
  initialState,
  reducers: {
    setLeaseCompMedia: (state, action: PayloadAction<LeaseMediaFiles>) => {
      if (!state.leaseMediaFiles) {
        state.leaseMediaFiles = {};
      }
      Object.entries(action.payload).forEach(([leaseCompId, mediaData]) => {
        if (!state.leaseMediaFiles[leaseCompId]) {
          state.leaseMediaFiles[leaseCompId] = {
            images: [],
            floorPlans: [],
            fliers: [],
          };
        }
        if (mediaData.images?.length) {
          state.leaseMediaFiles[leaseCompId].images = mediaData.images;
        }
        if (mediaData.floorPlans?.length) {
          state.leaseMediaFiles[leaseCompId].floorPlans = mediaData.floorPlans;
        }
        if (mediaData.fliers?.length) {
          state.leaseMediaFiles[leaseCompId].fliers = mediaData.fliers;
        }
      });
    },
    clearLeaseMedia: (state) => {
      state.leaseMediaFiles = {};
    },
  },
});

export const { setLeaseCompMedia, clearLeaseMedia } = leaseMediaSlice.actions;

export default leaseMediaSlice.reducer;
